import React, { useState, useEffect } from "react";
import "./styles/AdminStatistiks.css"; // Optional für Styling

const API_BASE_URL = "https://poke-meta.com/api"; // Stelle sicher, dass deine API über HTTPS läuft

const AdminStatistiks = () => {
  const [visitorCount, setVisitorCount] = useState(null);

  // Besucherzahl aus der API abrufen
  useEffect(() => {
    fetch(`${API_BASE_URL}/visitor-count`)
      .then((res) => res.json())
      .then((data) => {
        setVisitorCount(data.count); // Setzt den Besucherzähler
      })
      .catch((error) => console.error("Fehler beim Laden der Statistik:", error));
  }, []);

  return (
    <div className="admin-stats-container">
      <h1 className="admin-stats-title">Admin Statistiken</h1>
      
      <div className="stats-box">
        <h2>Besucheranzahl</h2>
        <p>{visitorCount !== null ? visitorCount : "Lade..."}</p>
      </div>

      {/* Hier können später weitere Statistiken hinzugefügt werden */}
    </div>
  );
};

export default AdminStatistiks;
